import styled from 'styled-components';
import { prop } from 'styled-tools';

export const StyledTitle = styled.h1`
  font-weight: 400;
  font-size: ${prop('size', '24')}px;
  margin: 0;
  letter-spacing: 1px;
`;
